import React from 'react';
import RoundButton from '../../../components/roundButton';
import {CenterStyle} from '../styles';
import {useIntl} from 'react-intl';

const CenterActions = ({
                           trace,
                           traceToggle,
                           followToogle,
                           follow,
                           onBlock,
                           createGeofence,
                           isDeviceTag,
                           onPressUpdate,
                           isFetchingTag,
                       }) => {
    const intl = useIntl();

    return (
        <CenterStyle id="center-actions">
            <div className='row d-flex align-items-start'>
                <RoundButton
                    labelDirection="bottom"
                    withBorder
                    label={intl.formatMessage({id: 'deviceRoute'})}
                    active={trace}
                    onClick={traceToggle}
                    className="mx-72px"
                >
                    <span className="fal fa-route"/>
                </RoundButton>

                <RoundButton
                    labelDirection="bottom"
                    withBorder
                    onClick={() => onBlock(true)}
                    className="mx-2"
                    label={intl.formatMessage({id: 'deviceBlock'})}
                    className="mx-72px"
                >
                    <span className="fas fa-lock-alt text-danger"/>
                </RoundButton>

                <RoundButton
                    labelDirection="bottom"
                    withBorder
                    onClick={() => onBlock(false)}
                    label={intl.formatMessage({id: 'deviceRelease'})}
                    className="mx-72px"
                >
                    <span className="fas fa-unlock-alt text-green"/>
                </RoundButton>

                <RoundButton
                    withBorder
                    labelDirection="bottom"
                    className="mx-2"
                    label={intl.formatMessage({id: 'deviceFollow'})}
                    active={follow}
                    onClick={followToogle}
                    className="mx-72px"
                >
                    <span className="fas fa-location-arrow"/>
                </RoundButton>

                <RoundButton
                    label={intl.formatMessage({id: 'deviceFence'})}
                    withBorder
                    labelDirection="bottom"
                    className=""
                    onClick={createGeofence}
                    className="mx-72px"
                >
                    <span
                        style={{fontSize: '2rem'}}
                        className="fal fa-location-circle fa-2x"
                    />
                </RoundButton>

                {isDeviceTag && (
                    <RoundButton
                        label={intl.formatMessage({id: 'actionUpdatePosition'})}
                        withBorder
                        labelDirection="bottom"
                        className="ml-2"
                        disabled={isFetchingTag}
                        onClick={onPressUpdate}
                        textWrap
                        className="mx-72px"
                    >
                        <span
                            style={{fontSize: '2rem'}}
                            className="fal fa-compass fa-2x"
                        />
                    </RoundButton>
                )}
            </div>
        </CenterStyle>
    );
};

export default CenterActions;
